@import "../../../styles/mixins/_search-skeleton";

.search-skeleton-container {
  margin: 8px -20px;
  background-color: white;
  padding: 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

@include search-skeleton;
